var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbs)?_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }